import React from "react";
import abbottLogo from "../img/Abbott_logo.png";
import productImage from "../img/Duphalac-image-new.png";
import H2Logo from "../img/H2Logo.png";
import HeaderComponent from "./headerComponent";
import { Link } from "react-router-dom";
import ThemeChangeIcon from "./themeChangeComponent";

const history = () => {
  // Handle Product Card Click
  const handleProductCardClick = () => {
    const url = `/Product/verify/01/08691234123416`;
    window.location.href = url;
  };

  return (
    <div class="row w-100 g-0">
      {/* theme change icon */}
      <ThemeChangeIcon />

      <div class="col-12 d-none d-lg-block col-lg-5 bg-image vh-100 position-fixed">
        <div className="mask text-light d-flex flex-column p-5 vh-100 w-100">
          <div class="logo-div float-start">
            {/* <img src={abbottLogo} class="w-100" alt="abbott logo" /> */}
            <Link className="navbar-brand company-logo company-logo-base" to="/">
              {/* <img src={abbottLogo} alt="abbott logo" className="w-100" /> */}
            </Link>
          </div>
          <div class="mt-auto text-start">
            <h3 class="fw-bold text-uppercase">welcome to abbott</h3>
            <h3 class="fw-bold text-uppercase display-6 text-color-primary pb-5">
              product verification
            </h3>

            <span class="pt-5 text-uppercase">
              *This is a mockup page showcasing digital serialization v2.8
            </span>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-7 offset-lg-5 d-flex flex-column vh-100">
        <div
          class="collapse mobile-nav-bar-menu-show"
          id="navbarToggleExternalContent"
          data-bs-theme="dark"
        >
          <div class="bg-dark p-4 text-start">
            <span class="text-body-secondary text-uppercase">
              *This is a mockup page showcasing digital serialization v2.8
            </span>
          </div>
        </div>

        <nav class="navbar navbar-dark bg-dark py-3 d-block d-lg-none">
          <div class="container-fluid px-4">
            <Link class="navbar-brand company-logo company-logo-base-mobile" to="/">
              {/* <img src={abbottLogo} alt="abbott logo" height="25" /> */}
            </Link>
            <button
              class="navbar-toggler border-0 ms-auto px-0"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarToggleExternalContent"
              aria-controls="navbarToggleExternalContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>
        </nav>

        <div class="d-block d-lg-none top-bg-img-container">
          <div class="top-bg-img">
            <div class="top-bg-img-overlay">
              <div class="pt-5 px-4 text-start">
                <h3 class="fw-bold text-uppercase text-color-white">
                  welcome to abbott
                </h3>
                <h3 class="fw-bold text-uppercase display-6 text-color-primary">
                  product verification
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-lg-4 pt-4 main-content-padding">
          <HeaderComponent />

          <div class="w-100 mt-5 d-flex d-lg-none text-start">
            <span class="fs-5 mb-3 text-color-white">Search History</span>
          </div>

          <div class="mt-2 d-flex flex-column w-100 d-block d-lg-none animate__animated animate__fadeIn">
            <div
              class="d-flex bg-color-white rounded-4 border border-light shadow-lg w-100 mb-4 product-history-card"
              onClick={handleProductCardClick}
            >
              <img
                src={productImage}
                class="rounded-4 float-start py-3 px-3 history-product-image"
                alt="productImage"
              />

              <div class="d-flex align-items-center ms-0 pe-3 ps-0 ms-lg-1">
                <h3 class="fw-semibold text-start">
                  DUPHALAC<sup>®</sup> SOLUTION
                </h3>
              </div>
            </div>
          </div>

          <div class="w-100 mt-4 mb-3 d-flex d-none d-lg-block text-start">
            <span class="fs-5">Search History</span>
          </div>

          <div class="col-12 d-none d-lg-block animate__animated animate__fadeIn">
            <div
              class="d-flex bg-color-white rounded-4 border w-100 mb-4 product-history-card"
              onClick={handleProductCardClick}
              style={{ cursor: "pointer" }}
            >
              <img
                src={productImage}
                class="rounded-4 float-start py-3 px-3 history-product-image"
                alt="product_image"
              />

              <div class="d-flex align-items-center ms-0 pe-3 ms-lg-1">
                <h3 class="fw-semibold text-start">
                  DUPHALAC<sup>®</sup> SOLUTION 300 ml
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-auto pb-2 main-content-padding">
          {/* <img src={H2Logo} alt="#" height="40" /> */}
          <a 
            href="https://h2compute.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            class="d-flex align-items-end text-decoration-none"
            style={{ cursor: 'pointer' }}
          >
            <span class="d-flex align-items-end me-2 text-color-gray small">
              Powered by:{" "}
            </span>
            <span class="h2c-logo"></span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default history;
